import { render } from "./ClassesSections.vue?vue&type=template&id=6a80d128&scoped=true"
import script from "./ClassesSections.vue?vue&type=script&lang=js"
export * from "./ClassesSections.vue?vue&type=script&lang=js"

import "./ClassesSections.vue?vue&type=style&index=0&id=6a80d128&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a80d128"]])

export default __exports__